const Echec = () => {
  return (
    <div>
      echec
    </div>
  );
};

export default Echec;